'use client'

import { useMemo } from 'react'

import { Navigation } from '@features/navigation.components/Navigation'
import { GetNavigationDocument } from '@features/navigation.graphql'
import { useQuery } from '@shared/apollo'
import { useParams, usePathname } from 'next/navigation'

import type { NavigationProps } from '@features/navigation.components/Navigation/types'

export const DocsNavigation = () => {
  const params = useParams()
  const pathname = usePathname()

  const slug = useMemo(() => {
    // The overview page will be the new landing page. We want to change the slug to root to display the root navigation.
    if (Array.isArray(params.slug)) {
      if (params.slug[0] === 'overview') {
        return '/'
      }

      return `/${params.slug.join('/')}`
    }

    // If the pathname is /ai-chatbot or /ai-chatbot/, we want to return the pathname. This is used for cases where DocsNavigation is used out of context of the [...slug] route.
    if (pathname === '/ai-chatbot' || pathname === '/ai-chatbot/') {
      return pathname
    }

    return `/${params.slug ?? ''}`
  }, [params.slug, pathname])

  const { data, loading } = useQuery(GetNavigationDocument, {
    variables: {
      input: { slug },
    },
  })

  const navigationData = data?.getNavigation as NavigationProps | null

  return (
    <Navigation
      items={navigationData?.items ?? []}
      loading={loading}
      parent={navigationData?.parent}
      path={navigationData?.path ?? []}
      title={navigationData?.title}
    />
  )
}
